import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import "@fontsource/libre-baskerville";

import '../assets/sass/main.scss';
import Footer from './Footer';
import Header from './Header';


class Layout extends Component {

  render() {
    const {
      children,
      noHeader,
      noFooter,
      activeLink,
    } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: 'A London based product and services company. Take a look at our catalog of items to see how we can transform your event into an unforgettable one.' },
                { name: 'keywords', content: 'wall drapes, back drops, chair covers, ' },
              ]}
            >
              <html lang="en" />
            </Helmet>
            <div id="content" className="main-content">
              {!noHeader ? <Header activeLink={activeLink} /> : null}
              {children}

              {!noFooter ? <Footer /> : null}
            </div>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  noFooter: PropTypes.bool,
  noHeader: PropTypes.bool,
  noSiteHeader: PropTypes.bool,
  activeLink: PropTypes.string,
};

export default Layout;
